import { render, staticRenderFns } from "./coletador.vue?vue&type=template&id=7f76c6ec"
import script from "./coletador.vue?vue&type=script&lang=js"
export * from "./coletador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports